module.exports = __webpack_public_path__ + "img/8pica.497eed1e.png";